import { useTranslation } from 'react-i18next'

import { Box, Button, Typography } from '@mui/material'

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import UndoIcon from '@mui/icons-material/Undo'

import { TLGTypography } from '@components/TLGTypography'

interface IEmailSentFeedbackProps {
  onSendAnotherMessageButtonClick: () => void
}

const EmailSentFeedback = ({
  onSendAnotherMessageButtonClick,
}: IEmailSentFeedbackProps) => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        width: {
          xs: '100%',
          lg: '46.8rem',
          xl: '52.8rem',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: {
          xs: 'center',
          lg: 'initial',
        },
      }}
    >
      <CheckCircleOutlineIcon
        sx={{
          width: '6rem',
          height: '6rem',
          color: '#81C784',
        }}
      />
      <TLGTypography
        responsiveVariant={{
          xs: 'h5',
          md: 'h4',
          lg: 'h3',
        }}
        sx={{
          marginTop: { xs: '0.8rem', lg: '2.4rem' },
        }}
      >
        {t('Information sent successfully')}
      </TLGTypography>

      <Typography
        sx={{
          textAlign: {
            xs: 'center',
            lg: 'initial',
          },
          marginTop: { xs: '1.6rem', md: '2.4rem' },
        }}
      >
        {t(
          'Thanks for reaching us. A representative from The Launchpad will be in touch with you soon.'
        )}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: { lg: 'center' },
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: '1.2rem', lg: '1.6rem' },
          marginTop: '2.1rem',
        }}
      >
        <Button
          data-testid="send-another-message-button"
          variant="outlined"
          size="medium"
          sx={{ order: { xs: 1, lg: 3 } }}
          onClick={onSendAnotherMessageButtonClick}
          endIcon={<UndoIcon />}
        >
          {t('SEND ANOTHER MESSAGE')}
        </Button>
      </Box>
    </Box>
  )
}

export { EmailSentFeedback }
